import type { IColorScheme } from './IColorScheme';
import { storeColorScheme } from './colorSchemeStorage';
import { findColorScheme } from './findColorScheme';

/**
 * Застосовує схему до документа: <html data-scheme="…" data-mode="light|dark"> (правила токенів — styles/schemes.css),
 * CSS color-scheme для нативних контролів і прокрутки; запам'ятовує вибір у localStorage. Повертає фактично застосовану схему
 * (невідомий ключ → «Парламент»). Поза браузером (тести, SSR) лише повертає схему.
 */
export function applyColorScheme(id: string | null | undefined): IColorScheme {
  const scheme = findColorScheme(id);
  if (typeof document === 'undefined') return scheme;
  const root = document.documentElement;
  root.dataset['scheme'] = scheme.id;
  root.dataset['mode'] = scheme.mode;
  root.style.colorScheme = scheme.mode;
  delete root.dataset['theme'];
  storeColorScheme(scheme);
  return scheme;
}
